import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * Represents the [KendoReact Drawer component]({% slug overview_drawer %}).
 *
 * @example
 * ```jsx
 * const App = () => {
 *   const items = [
 *       { text: 'Inbox', icon: 'k-i-inbox', selected: true },
 *       { separator: true },
 *       { text: 'Notifications', icon: 'k-i-bell', disabled: true },
 *       { text: 'Calendar', icon: 'k-i-calendar' },
 *       { separator: true },
 *       { text: 'Attachments', icon: 'k-i-hyperlink-email' },
 *       { text: 'Favourites', icon: 'k-i-star-outline' }
 *   ];
 *
 *   const [expanded, setExpanded] = React.useState(true);
 *   const handleClick = () => setExpanded(prevState => !prevState);
 *
 *   return (
 *       <Drawer expanded={expanded} position='start' mode='push' items={items}>
 *           <DrawerContent>
 *               <button className="k-button" onClick={handleClick}>Toggle the drawer state</button>
 *           </DrawerContent>
 *       </Drawer>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
export var DrawerContent = React.forwardRef(function (props, target) {
    var children = props.children, className = props.className, style = props.style;
    var elementRef = React.useRef(null);
    React.useImperativeHandle(target, function () { return ({
        element: elementRef.current
    }); });
    var contentClassNames = classNames({
        'k-drawer-content': true
    }, className);
    return (React.createElement("div", { className: contentClassNames, style: style, ref: elementRef }, children));
});
DrawerContent.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object
};
DrawerContent.displayName = 'KendoDrawerContent';
//# sourceMappingURL=DrawerContent.js.map